// extracted by mini-css-extract-plugin
export default {"tagline":"Tagline-module--tagline--c1652","small":"Tagline-module--small--36ee8"};